var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"min-height":"194"}},[_c('v-card-title',[_vm._v("Ranking")]),_c('div',{staticClass:"card-meta pa-4"},[_c('v-row',{attrs:{"justify":"center"}},[_vm._v(" Em Breve ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }